export enum LocationTypeEnum {
    Warehouse = 'warehouse',
    Production = 'production',
    Store = 'store',
    Workplace = 'workplace',
    BreakArea = 'break_area',
    Amenity = 'amenity',
    Transit = 'transit',
    OutsideCompany = 'outside_company',
}

export const WORKING_LOCATION_TYPES: ReadonlyArray<LocationTypeEnum> = [
    LocationTypeEnum.Warehouse,
    LocationTypeEnum.Production,
    LocationTypeEnum.Store,
    LocationTypeEnum.Workplace,
];

export const IGNORED_LOCATION_TYPES: ReadonlyArray<LocationTypeEnum> = [LocationTypeEnum.OutsideCompany];

export const isWorkingLocationType = (type: LocationTypeEnum | string | null | undefined): boolean => {
    return type !== null && type !== undefined && (WORKING_LOCATION_TYPES as readonly string[]).includes(type);
};

export const isIgnoredLocationType = (type: LocationTypeEnum | string | null | undefined): boolean => {
    return type !== null && type !== undefined && (IGNORED_LOCATION_TYPES as readonly string[]).includes(type);
};
